import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=b1872f5e&scoped=true&"
import script from "./InsLayer.vue?vue&type=script&lang=ts&"
export * from "./InsLayer.vue?vue&type=script&lang=ts&"
import style0 from "./InsLayer.vue?vue&type=style&index=0&id=b1872f5e&prod&lang=less&"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=b1872f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1872f5e",
  null
  
)

export default component.exports